import { useSelector } from "react-redux";

export const useUIData = () => useSelector(({ ui }) => ui);
